export const KICKSTARTER_MAILCHIMP_TAGS = ["LP Kickstarter"]
export const KICKSTARTER_MAILCHIMP_STATUS = "subscribed"
export const KICKSTARTER_PAGE_PATH = "/kickstarter"
